<template>
  <transition name="fade" mode="out-in">

    <div class="animated fadeIn form-mimoto">

    <CRow class="mb-4">
      <CCol md="12">
        <h2> <strong> {{elemento}}</strong> </h2>
        <p class="mb-0">Plan XXX en el parking XXX</p>
      </CCol>
    </CRow>


    <CCard>
      <CCardBody borderColor="primary">
        <h5 class="subtitle mb-1">7. Finalizado</h5>
        <!-- <p class="mb-3 text-primary">Pulsa siguiente para confirmar el pedido</p> -->

        <CForm @submit.prevent data-vv-scope="new-delivery">

          <CRow>
            <CCol sm="12">

            </CCol>

          </CRow>


        </CForm>

        <p class="invalid-feedback d-block mt-4 mb-3">
          {{ message }}
        </p>

       <toast ref="toast"></toast>

      </CCardBody>
    </CCard>

    <div class="title-container mb-3 btn-new-delivery">
      <button @click.prevent="saveDelivery" class="btn-login-new-delivery btn" >
        <!-- Siguiente -->
        ver mis planes
      </button>
    </div>

    <spinner-ttt :show="loading"></spinner-ttt>


    </div>
  </transition>
</template>

<script>
import validator from "@/validator";
// import apiTools from "@/app/shared/utils/apiTools"
import { CALENDAR_LANG } from "@/config";

import { createDelivery, getProductStore, setProductStore } from "@/app/shared/global/services/product-service";

import { fetchOneParking } from "@/app/shared/global/services/parking-service";
// detalle del plan seleccionado

export default {
  name: "ContractSuccess",
  components: {

  },
  data() {
    return {
      step: 7,
      elemento: "Pedido finalizado",
      loading: true,
      message: null,

      product: {
        clients_id: localStorage.getItem('user_id'),
        towns_id: null, // solo para ir hacia a trás
        parkings_id: null,
        plans_id: null, // plans
        start_datetime: null,
        end_datetime: null,
        dates: [],
        hours:[],
      },

      errorDates: false,
      lang: CALENDAR_LANG,

      contractPlanApi: null,

      errorPlan: false,

      parkings: [],
      planes: [],
      parking: null,

    };
  },
  created() {


    this.getParking();
  },
  mounted(){

    this.$emit("updateStep", this);
    this.$emit("showButtons", false);

    // if (getProductStore()){
    //   this.setDataLocalStorage();
    // }

  },

  methods: {

    async getParking() {

      try {

        const resp = await fetchOneParking();

        if (resp.status !== 'success') {
          this.$refs.toast.showToast(`Error al obtener el parkings`, null, 'error', '2000');
          return;
        }

        this.parking = resp.data;

      } catch (err) {
        console.log(err);
        this.$refs.toast.showToast(`Error al obtener el parking`, null, 'error', '2000');

      } finally {
        this.loading = false;
      }
    },

    saveDelivery() {

      this.$validator.validateAll('new-delivery').then( async (valid) => {


        if (this.product.dates.length <= 0 || this.product.dates.some(date => date === null)) {
          this.message = `Debes indicar el rango de fechas que aplicará el ${this.element}`;
          this.errorDates = true;
        }

        if (valid ) {

          this.loading = true;
          const errorMessage = `Se ha producido un error seleccionar la fecha`;

          try {

            const contractToSave = {
              parkings_id: this.product.parkings_id.value,
            }


            this.contractPlanApi = {...contractToSave};

            this.nextStep();

          } catch (e) {
            console.log(e);
            this.$refs.toast.showToast(`${errorMessage}`, null, 'error', '2000');

          } finally {
            this.loading = false;
          }

        } else {
          this.$refs.toast.showToast("Todos los campos son requeridos",null,"error","5000");
        }
      })
    },

    setDataLocalStorage() {

      const errorMessage = `Se ha producido un error al obtener los datos en curso`;
      this.loading = true;

      try {
        let storedData = getProductStore();

        if (storedData) {

          // set id address, se guarda en le store el id del address inmutable
          const labelPickup = storedData.pickup_address_detail.store ?
          `${storedData.pickup_address_detail.alias} - ${storedData.pickup_address_detail.address}` :
          storedData.pickup_address_detail.address;

          const labelDelivery = storedData.delivery_address_detail.store ?
          `${storedData.delivery_address_detail.alias} - ${storedData.delivery_address_detail.address}` :
          storedData.delivery_address_detail.address

          this.product = {
            parkings_id: {
              label: labelPickup,
              value: storedData.pickup_address_detail.addresses_id
            },
          };
        }

      } catch (e) {
        console.log(e);
        // this.$refs.toast.showToast(`${errorMessage}`,null,"warn","5000");
      } finally {
        this.loading = false;
      }

    },

    saveDataLocalStorage() {
      setProductStore(this.contractPlanApi);
    },


    nextStep() {

      this.loading = true;
      this.saveDataLocalStorage();

      // const data = { valid: true, parkingId: this.contractPlanApi.parkings_id }
      this.$emit("validForm", { valid: true, parkingId: this.contractPlanApi.parkings_id } );
      this.loading = false;



    },



    formatDataSelect(ad) {

      if (ad) {
        const label = ad.store ? `${ad.alias} - ${ad.address}` : ad.address

        return {
          label: label, //`${ad.alias} - ${ad.address}`,
          value: ad.id
        }
      }
    },






  }
};
</script>

<style lang="scss" scoped>


.input-group-append {
  .input-group-text {
    color: #1c1f22; //#5c6873;
    background-color: var(--theme-color-primary)!important;// #f0f3f5; //
    border-color: var(--theme-color-primary); //#e4e7ea;
  }
}


</style>
